import React from 'react';

import { Box } from '@mantine/core';
import KiloAlert from 'components/KiloAlert';

const UncreditedReservationsAlert = (): JSX.Element => {
  return (
    <Box>
      <KiloAlert variantStyle='warning'>
        Credits will be assigned nightly to uncredited reservations in chronological order if there are
        credits available and the reservation is within 30 days. You can also assign credits manually by
        clicking the uncredited reservation.
      </KiloAlert>
    </Box>
  );
};

export default UncreditedReservationsAlert;
